//List of languages available
export const LANGUAGES = [
      {
        'code': 'en',
        'label': 'translations.language.en'
      },

    {
        'code': 'fr',
        'label': 'translations.language.fr'
    }

];

export const LANG_STORAGE_KEY = 'lang';

export const DEFAULT_LANG_VALUE = 'en';
